import { useGrowthbook } from '@experience/core-hostapp-share-lib';

const EXP_KEY = 'exp-card-mini-discount';

export const useExpCardMiniDiscount = () => {
  const gb = useGrowthbook();

  const isExpCardMiniDiscountActive = gb?.isOn(EXP_KEY) ?? false;

  return {
    isExpCardMiniDiscountActive,
  };
};
